import React, { useState, useEffect } from 'react';
import { Button, Typography, Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { Floor } from '@one-thd/sui-icons';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import {
  useDataModel,
} from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
const { string } = proptypes;
import { cppDataModel } from './dataModel';
import { SEARCH_TYPE, PRODUCT_LINE, CPP_URL } from '../constants';

export const CPPWidget = ({ itemId }) => {
  const [hasCarpetProjects, setHasCarpetProjects] = useState(false);
  const { svocID } = useThdCustomer() || {};

  const { data, loading } = useDataModel('getDesignIdsBySearchTerm', {
    variables: {
      searchTerm: svocID,
      searchType: SEARCH_TYPE,
      productLine: PRODUCT_LINE
    },
    ssr: false
  });

  const { data: productData, loading: productLoading } = useDataModel('clientOnlyProduct', {
    skip: !itemId,
    ssr: false,
    variables: {
      itemId
    }
  });

  useEffect(() => {
    if (!loading && data?.getDesignIdsBySearchTerm) {
      let designIDsResponse = data.getDesignIdsBySearchTerm.replace(/\[|\]/g, '').split(' ');
      setHasCarpetProjects(designIDsResponse.length > 0);
    } else {
      setHasCarpetProjects(false);
    }
  }, [data, loading]);

  const isInstalledCarpet = productData?.product?.taxonomy?.breadCrumbs?.some(
    (breadCrumb) => breadCrumb.label === 'Installed Carpet'
  );

  if (productLoading || !isInstalledCarpet) return null;

  return (
    <div
      className="sui-bg-primary sui-gap-2 sui-items-center sui-flex sui-flex-wrap
        sui-justify-between"
      data-component="CPPWidget"
    >
      {loading && (
        <Skeleton
          density="normal"
          PaperProps={{
            className: 'sui-grow'
          }}
        >
          <SkeletonBlock
            aspect="wide"
            height={12}
            width="100%"
          />
        </Skeleton>
      )}
      {!loading && (
        <>
          <div className="sui-flex sui-flex-row sui-gap-2">
            <div className="sui-self-center">
              <Floor size="large" />
            </div>
            <div className="sui-flex sui-flex-col">
              <Typography variant="h5" truncate>
                {hasCarpetProjects ? 'Did you save a carpet project?' : 'Easily manage your carpet projects'}
              </Typography>
              <Typography component="span" variant="body-base">
                <div className="sui-text-sm sui-w-full sui-whitespace-pre-wrap">
                  {hasCarpetProjects
                    ? 'Revisit your saved carpet projects anytime in your account'
                    : 'View and edit any saved carpet projects in your account'}
                </div>
              </Typography>
            </div>
          </div>
          <Button
            variant="secondary"
            href={CPP_URL}
          >
            View Projects
          </Button>
        </>
      )}
    </div>
  );
};

CPPWidget.displayName = 'CPPWidget';
CPPWidget.dataModel = cppDataModel;
CPPWidget.propTypes = {
  itemId: string.isRequired
};